import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexContainer, FlexItem } from '../../styled/layout.styled';
import { Caption } from '../../styled/typograpghy.styled';
import settingsIcon from './assets/Settings.svg';
import deleteIcon from './assets/Delete.svg';
import DataCard from '../reusable/DataCard';
import CopyClip from '../reusable/CopyClip/CopyClip';
import dateFormat from '../../utils/dateFormat';

const StyledFlexContainer = styled(FlexContainer)`
  border-radius: 4px;
  background-color: #22096c;
  @media only screen and (max-width: 568px) {
    border-radius: 0;
  }
`;

const StyledH3 = styled.h5`
  margin: 0 0 8px 0;
  color: #ffffff;
  white-space: nowrap;
`;

const StyledIconsContainer = styled(FlexContainer)`
  display: none;
  img {
    cursor: pointer;
  }
  @media only screen and (max-width: 568px) {
    display: flex;
    align-items: baseline;
  }
`;

const StyledSettingsIconContainer = styled(FlexItem)`
  display: flex;
  img {
    cursor: pointer;
    padding-top: 13px;
    margin: 0 33px 0 0;
  }
  @media only screen and (max-width: 568px) {
    display: none;
  }
`;

const CampaignsBlog = ({
  name, visits, referrals, wagered, commission, link, createdAt, deleteOnOpen, editOnOpen,
}) => (
  <StyledFlexContainer mobilePadding="16px" padding="32px" flexDirection="column" margin="0 0 8px 0">
    <FlexContainer
      mobileFlexWrap
      width="100%"
      justifyContent="space-between"
      mobileJustifyContent="space-between"
      tabletFlexWrap
    >
      <FlexContainer flexDirection="column" width="27%" mobileWidth="57%" mobileMargin="0 0 31px 0">
        <StyledH3>{name}</StyledH3>
        <Caption color="#c7baf1">{dateFormat(createdAt)}</Caption>
      </FlexContainer>

      <StyledIconsContainer
        mobileJustifyContent={name === 'Default Campaign' ? 'flex-end' : 'space-between'}
        mobileWidth="20%"
      >
        <FlexItem onClick={() => editOnOpen()}>
          <img src={settingsIcon} alt="settingIcon" />
        </FlexItem>
        {name === 'Default Campaign' ? null : (
          <FlexItem onClick={() => deleteOnOpen()}>
            <img src={deleteIcon} alt="deleteIcon" />
          </FlexItem>
        )}
      </StyledIconsContainer>

      <FlexContainer
        justifyContent="space-between"
        mobileJustifyContent="space-between"
        tabletJustifyContent="flex-end"
        width="69%"
        tabletWidth="100%"
        mobileFlexWrap
        tabletMargin="24px 0 0 0"
      >
        <FlexItem width="19.5%" mobileWidth="49%" tabletWidth="16%">
          <DataCard campaignBlogCard name="Visits" value={visits} padding="16px 0 18px 16px" gradientDirection />
        </FlexItem>
        <FlexItem width="19.5%" mobileWidth="49%" tabletWidth="16%" tabletMargin="0 0 0 8px">
          <DataCard campaignBlogCard name="Referrals" value={referrals} padding="16px 0 18px 16px" gradientDirection />
        </FlexItem>
        <FlexItem width="28%" mobileWidth="49%" tabletWidth="23%" tabletMargin="0 0 0 8px">
          <DataCard
            campaignBlogCard
            name="Wagered"
            value={wagered}
            padding="16px 0 18px 16px"
            gradientDirection
            bsIcon
          />
        </FlexItem>
        <FlexItem width="28%" mobileWidth="49%" tabletWidth="23%" tabletMargin="0 0 0 8px">
          <DataCard
            campaignBlogCard
            name="Commission"
            value={commission}
            padding="16px 0 18px 16px"
            gradientDirection
            bsIcon
          />
        </FlexItem>
      </FlexContainer>
    </FlexContainer>

    <FlexContainer justifyContent="space-between" mobileMargin="24px 0 0 0" margin="24px 0 0 0">
      <StyledSettingsIconContainer width="50%" margin="0 0 0 0" mobileDisplay="none">
        <FlexItem onClick={() => editOnOpen()}>
          <img src={settingsIcon} alt="settingsIcon" />
        </FlexItem>
        {name === 'Default Campaign' ? null : (
          <FlexItem onClick={() => deleteOnOpen()}>
            {' '}
            <img src={deleteIcon} alt="deleteIcon" />{' '}
          </FlexItem>
        )}
      </StyledSettingsIconContainer>
      <FlexItem width="100%" mobileWidth="100%">
        <CopyClip link={link} />
      </FlexItem>
    </FlexContainer>
  </StyledFlexContainer>
);

CampaignsBlog.propTypes = {
  name: PropTypes.string.isRequired,
  visits: PropTypes.number.isRequired,
  referrals: PropTypes.number.isRequired,
  wagered: PropTypes.number.isRequired,
  commission: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  createdAt: PropTypes.any.isRequired,
  deleteOnOpen: PropTypes.func.isRequired,
  editOnOpen: PropTypes.func.isRequired,
};

export default memo(CampaignsBlog);
